import { EnvConfig } from "@/config/env";

type TCommonOptions = {
  isAbsolute?: boolean;
};
type TSinglePost = {
  route: "post";
  slug: string;
};
type TPostsFeed = {
  route: "home";
};
type TPostsByTag = {
  route: "posts-by-tag";
  tag: string;
};
type TSearchPostsByTerm = {
  route: "search-posts-by-term";
  term: string;
};
function build(
  args: (TSinglePost | TPostsFeed | TPostsByTag | TSearchPostsByTerm) &
    TCommonOptions,
) {
  let link: string;
  switch (args.route) {
    case "post":
      link = `/post/${args.slug}`;
      break;
    case "search-posts-by-term":
      link = `/search/${args.term}`;
      break;
    case "posts-by-tag":
      link = `/tag/${args.tag}`;
      break;
    case "home":
      link = "/";
      break;
    default:
      console.warn(`Unknown link route. Args:`, args);
      link = "/";
  }
  return args.isAbsolute ? EnvConfig.siteUrl + link : link;
}

export const LinkBuilder = {
  build,
};
